import './sass/main.scss';
import './js/get-movies';
import './js/insert-movies';
import './js/theme';
import './js/loader';
import './js/modal-auth';
import './js/movie-genres';
import './js/search-movies';
import './js/refs';
import './js/pagination';
import './js/film-modal';
import './js/home-library-btns';
import './js/render-local-movies';
import './js/search-form';
import './js/header-mylib';
import './js/language';
import './js/scrolltop';
import './js/trailer-api';
import './js/movie-trailer';
import './js/firebase/firebase-cnfg';
